import { MantineReactTable } from "mantine-react-table"

const ListProduct = () => {
    return (
        <></>
    )
}

export default ListProduct;